import React, { useContext } from "react";
import {
  IonPage,
  IonRow,
  IonCol,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid,
  IonHeader,
  IonToolbar,
  IonBackButton,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/react";
import { Auth } from "aws-amplify";
import { ApplicationContext, ProviderContext } from "../ApplicationState";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "./Home.css";
import jwt_decode from "jwt-decode";
import UsersComponent from "../components/UsersComponent";
import TotalReadingsChart from "../components/Charts/TotalReadingsChart";
import DrawPieChart from "../components/Charts/UsersCountChart";
import GroupReadingsComponent from "../components/GroupReadingsComponent";
import DrawLineChart from "../components/Charts/MeasurementChart";
import MeasurementChart from "../components/Charts/MeasurementChart";
import UsersCountChart from "../components/Charts/UsersCountChart";
import { arrowBackCircleSharp, addCircle } from "ionicons/icons";
import { LabelSharp } from "@mui/icons-material";
import { useTranslations } from "../hooks/useTranslations";

const logout = () => {
  Auth.signOut();
};

const getDecodedAccessToken = (token: string) => {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
};

const ContactUs: React.FC<any> = (props) => {
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);
  const labels = useTranslations()

  return (
    <IonPage>
      <Header />
      <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text={labels.Goback}
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />
          </IonButtons>
          <IonTitle>{labels.ContactUs}</IonTitle>

        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonCard>
          <IonCardHeader>
            <IonTitle>{labels.ContactUs}</IonTitle>
          </IonCardHeader>
          <IonCardContent className="h4">
            {labels.ContactUsEmail}{" "}
            <a href="mailto: MedlineHealthApp@medline.com" target="_blank">
              MedlineHealthApp@medline.com
            </a>
            .
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default ContactUs;
